import { z } from 'zod';

export const OrganizationTypeSchema = z.enum(['platform', 'client', 'carrier', 'supplier']);

export type OrganizationType = z.infer<typeof OrganizationTypeSchema>;

export const OrganizationTypesSchema = z.array(OrganizationTypeSchema);

export type OrganizationTypes = z.infer<typeof OrganizationTypesSchema>;

export const NetSuitePaymentTermSchema = z.object({
    daysTillNetDue: z.number(),
    description: z.string(),
    externalId: z.number(),
    id: z.number(),
    isEnabledInNetSuite: z.boolean(),
    position: z.number(),
    version: z.number(),
});

// Warning: This schema is used against monolith endpoint response of '/organizations'
// which returns a stripped-down representation of an organization entity !.
export const OrganizationSchema = z.object({
    id: z.number(),
    name: z.string(),
    billingAddress: z.object({
        city: z.string(),
        country: z.string(),
        number: z.string(),
        state: z.string(),
        street: z.string(),
        zip: z.string(),
    }),
    marketCode: z.string(),
});

// TODO: consolidating the Organization types will be handled in this ticket [ORD-816]:
// https://linear.app/schuettflix/issue/ORD-816/consolidate-organization-types

export const ExtendedOrganizationSchema = OrganizationSchema.extend({
    isPartnerInvoicingEnabled: z.boolean(),
    clientPaymentTerm: NetSuitePaymentTermSchema.optional(),
    supplierPaymentTerm: NetSuitePaymentTermSchema.optional(),
    carrierPaymentTerm: NetSuitePaymentTermSchema.optional(),
});

export type ExtendedOrganization = z.infer<typeof ExtendedOrganizationSchema>;
export type Organization = z.infer<typeof OrganizationSchema>;

// Note: This schema does not contain all fields. Feel free to extend whenever needed.
export const OrganizationMetadataSchema = z.object({
    id: z.number(),
    types: OrganizationTypesSchema,
    name: z.string(),
    billingAddress: z.object({
        city: z.string(),
        country: z.string(),
        number: z.string(),
        state: z.string(),
        street: z.string(),
        zip: z.string(),
    }),
    tmsProvider: z.enum(['trent']).nullish(),
    vatId: z.string().nullable(),
});
export type OrganizationMetadata = z.infer<typeof OrganizationMetadataSchema>;
